export const raise = ( msg: string ): never => {
	const err = new Error(msg) as Error & { parsed: { method: string, path: string, line: string, column: string, parts: string[] }[] };
	const [ errantMethod, ...stack ] = err.stack.split('\n');
	const parsed = stack.map(l => l.split(/[()]/g)).map(p => {
		const method = p[0].replace(/\ |at/g, "");
		const pathURL = new URL(p[1].split(":").slice(0, -2).join(":"));
		const [ line, column, ] = p[1].split(":").slice(-2);
		const internal = pathURL.pathname.includes("/node_modules/");
		return { method, path: pathURL.pathname, line, column, internal, parts: p, };
	});

	console.group(`--- ${errantMethod} ---`);
	console.table(parsed);
	console.groupEnd();

	throw err;

};
